import { type MapStore, map } from 'nanostores';

import type { SyncSettings } from './client/sync_client.js';
import { addSyncCapabilities, type SyncMap } from './sync_store.js';

export type { SyncMap };

export function syncMap<Value extends object>(
  name: string,
  initial: Value | undefined,
  syncSettings: SyncSettings<MapStore<Value>>,
): SyncMap<Value> {
  const { syncClient } = syncSettings;
  const store = map<Value>(initial);

  // Add sync capabilities (including set override)
  const syncStore = addSyncCapabilities(store, name, syncSettings);

  // Override setKey to handle synchronization
  const originalSetKey = syncStore.setKey;
  syncStore.setKey = (key, value) => {
    if (syncClient.isSyncing && syncStore.unconfirmed) {
      // Only ignore updates to keys that have unconfirmed changes
      const unconfirmed = syncStore.unconfirmed;
      if (typeof unconfirmed === 'string') {
        return;
      }
      if (unconfirmed[String(key)]) {
        return;
      }
    }
    originalSetKey(key, value);
  };

  return syncStore;
}
